module.exports = __webpack_public_path__ + "img/chinesecompany94.27092b20.png";